/**
 * Sync Stage Constants
 * 
 * Centralized definition of all sync stages and their metadata.
 * Keep in sync with Python version at /DataService/sync_stages.py
 */

export const SYNC_STAGES = {
  INIT: 'init',
  AUTH: 'auth', 
  FETCH: 'fetch',
  REPORTS: 'reports',
  HEALTH: 'health',
  COMPLETE: 'complete',
  ERROR: 'error'
};

export const SYNC_STAGE_CONFIG = {
  [SYNC_STAGES.INIT]: {
    title: 'Initialization',
    description: 'Starting data sync process',
    icon: '🚀',
    progress: 10
  },
  [SYNC_STAGES.AUTH]: {
    title: 'Authentication',
    description: 'Connecting to data source',
    icon: '🔐',
    progress: 25
  },
  [SYNC_STAGES.FETCH]: {
    title: 'Data Retrieval',
    description: 'Fetching records from source',
    icon: '📥',
    progress: 40
  },
  [SYNC_STAGES.REPORTS]: {
    title: 'Financial Reports',
    description: 'Retrieving financial reports',
    icon: '📊',
    progress: 60
  },
  [SYNC_STAGES.HEALTH]: {
    title: 'Health Check',
    description: 'Calculating health score',
    icon: '❤️',
    progress: 80
  },
  [SYNC_STAGES.COMPLETE]: {
    title: 'Complete',
    description: 'Sync completed successfully',
    icon: '✅',
    progress: 100
  },
  [SYNC_STAGES.ERROR]: {
    title: 'Error',
    description: 'Sync encountered an error',
    icon: '❌',
    progress: 0
  }
};

/**
 * Get progress percentage for a given stage
 */
export const getStageProgress = (stage) => {
  return SYNC_STAGE_CONFIG[stage]?.progress || 0;
};

/**
 * Get stage configuration for a given stage
 */
export const getStageConfig = (stage) => {
  return SYNC_STAGE_CONFIG[stage] || null;
};

/**
 * All sync stages that indicate an active sync (excluding complete/error)
 */
export const ACTIVE_SYNC_STAGES = [
  SYNC_STAGES.INIT,
  SYNC_STAGES.AUTH,
  SYNC_STAGES.FETCH,
  SYNC_STAGES.REPORTS,
  SYNC_STAGES.HEALTH
];

/**
 * All sync stages that indicate sync completion (success or failure)
 */
export const TERMINAL_SYNC_STAGES = [
  SYNC_STAGES.COMPLETE,
  SYNC_STAGES.ERROR
];

/**
 * All valid sync stages
 */
export const ALL_SYNC_STAGES = Object.values(SYNC_STAGES);